import type { JSX } from 'react'

import { InlinePrimaryLoginTemplate } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBoxCaption3, TextBoxCaption3Secondary } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { model as verifyModel } from '../model'

VerifyTextBlock.displayName = 'VerifyTextBlock'
export function VerifyTextBlock({
  liveTo,
  liveResendIn,
}: {
  liveTo?: string | null
  liveResendIn?: string | null
}): JSX.Element | null {
  const { t } = useTranslation()

  const permanentError = useUnit(verifyModel.$permError)
  const pending = useUnit(verifyModel.confirmCodeRegistrationFx.pending)
  const locked = useUnit(verifyModel.$locked)
  const requestNewConfirmationCode = useUnit(
    verifyModel.requestNewConfirmationCode
  )

  if (liveTo === null) {
    return <TextBoxCaption3 title={t('request_expired_error')} />
  }

  if (permanentError) {
    return <TextBoxCaption3 title={t(permanentError)} />
  }

  if (liveResendIn) {
    return (
      <TextBoxCaption3Secondary
        title={t('code_request_new_timer_web', {
          time: liveResendIn,
        })}
      />
    )
  }

  return (
    <InlinePrimaryLoginTemplate
      title={t('code_request_new')}
      disabled={pending || locked}
      onClick={requestNewConfirmationCode}
    />
  )
}
